import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { IconError } from "../../Assets/IconError";
import { Autocomplete, Box, TextField } from "@mui/material";



const Styles = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
  &.ltr-all {
    /* @noflip */
    .text-field {
      &.ltr-help {
        padding: calc(var(--fs-textfield) * 2.3) calc(3rem - 1px) calc(var(--fs-textfield) * 0.7) calc(1rem - 1px);
      }
    }
    .eye {
      left: auto;
      right: calc(var(--fs-textfield) * 1);
    }
    .label-textinput{
      right: auto;
      left: calc(var(--fs-textfield) * 1);
    }
    .help-input{
      left: auto;
      right: calc(var(--fs-textfield) * 1);
    }
  }
  &.search {
    .MuiAutocomplete-inputRoot {
      border-radius: var(--border-radius-2);
    }
  }
  .text-field {
    z-index: 3;
    width: calc(100%);
    padding: calc(var(--fs-textfield) * 2) calc(0.5rem - 1px) calc(var(--fs-textfield) * 0.8);
    border-radius: var(--border-radius-2);
    border: 1px var(--n-grey-2) solid;
    outline: none;
    transition: var(--trans-1);
    font-size: var(--fs-textfield);
    background: transparent;
    &.error-text {
      border: 1px var(--secondry-1) solid;
    }
    &.ltr-text {
      direction: ltr;
      text-align: left;
    }
    :focus {
      border: 1px var(--border-3) solid;
    }
    &.disabled {
      background-color: var(--n-grey-01);
      color: var(--n-grey-5);
      &[disabled='disabled']::-ms-value {
        color: var(--n-grey-5);
      }
    }
  }
  .label-textinput{
    z-index: 2;
    position: absolute;
    top: calc(var(--fs-textfield) * 1.5);
    right: calc(var(--fs-textfield) * 1.5);
    transition: var(--trans-1);
    &.active{
      z-index: 5;
      top: calc(var(--fs-textfield) * 0.5);
      font-size: calc(var(--fs-textfield) * 0.8);
    }
  }
  
  .error {
    display: flex;
    height: 1rem;
    font-size: var(--fs-small);
    .icon {
      width: 1rem;
      height: 1rem;
    }
    .text {
      margin: 0.1rem 0.2rem 0 0;
      color: red;
    }
  }
  @media screen and (max-width: 1445px) {
    &.search {
      .MuiAutocomplete-inputRoot {
        padding: 0.3rem 0.5rem 0.2rem;
        border-radius: var(--border-radius-2);
      }
      .MuiInputLabel-root {
        translate: 0 -4px;
        &.Mui-focused, &.MuiInputLabel-shrink {
          translate: 0 0px;
        }
      }
    }
    .text-field {
      padding: calc(var(--fs-textfield) * 1.4) calc(0.5rem - 1px) calc(var(--fs-textfield) * 0.5);
    }
    .label-textinput{
      top: calc(var(--fs-textfield) * 1.05);
      right: calc(var(--fs-textfield) * 1.05);
      &.active{
        top: calc(var(--fs-textfield) * 0.3);
        font-size: calc(var(--fs-textfield) * 0.8);
      }
    }
  }
`;

export const SelectInputWTitle = ({
  style,
  name,
  title,
  error,
  options,
  first,
  value,
  onchange,
  placeHolder,
  required,
  ltr,
  lang="en",
  lan=false,
  disabled=false,
  selectableFirst= false,
  search=false,
}) => {
  const [focused , setFocused] = useState(false);
  const [searched , setSearched] = useState("");
  
  useEffect(() => {
    if(!value || value === ''){
      setFocused(false);
    } else {
      setFocused(true);
    }
  }, [value]);

  let errorComp = "";
  let classes = "text-field";
  if (error && error.toString()) {
    classes = "text-field error-text";
    errorComp = (
      <React.Fragment>
        <IconError />
        <div className="text">{error}</div>
      </React.Fragment>
    );
  }
  if (ltr) {
    classes += " ltr-text";
  }
  const makeOption = () => {
    let optionsView = [];
    if (first) {
      let dis = {disabled: true};
      if(selectableFirst){
        dis = {}
      }
      optionsView.push(<option key={-1} value={""} {...dis}>{(typeof first === 'boolean') ? '' : first}</option>);
    }
    if (options) {
      options.forEach((element, index) => {
        if(typeof element.name === "object" && element.name){
          optionsView.push(<option key={index} value={element.value}>{element.name[lang]}</option>);
          return;
        }
        optionsView.push(<option key={index} value={element.value}>{element.name}</option>);
      });
    }
    return optionsView;
  };
  const changed = (e, newvalue) => {
    if(typeof onchange !== "function"){
      return;
    }
    if(newvalue){
      onchange({
        target: {
          value: newvalue.value,
          name: name,
        }
      })
    } else {
      onchange({
        target: {
          value: "",
          name: name,
        }
      })
    }
  }
  if(!options){
    return;
  }
  if(search){
    let dir = (lan ? "ltr" : "rtl")
    return (
      <Styles style={style} className={((lan) ? "ltr-all" : "") + " search"}>
        <Autocomplete
          disablePortal
          dir={dir}
          options={options}
          onChange={changed}
          isOptionEqualToValue={(option, value2) => {
            if(value2 === ""){
              return false;
            }
            if(typeof option.value === "string"){
              return option.value === value2
            }
            return parseInt(option.value) === parseInt(value2)
          }}
          value={value}
          autoHighlight={true}
          getOptionLabel={(option) => {
            if(option === ""){
              return ""
            }
            if(options.length === 0){
              return "";
            }
            if(typeof option === "object"){
              return option.name
            }
            if(typeof option === "string"){
              let find = options.findIndex((v) => v.value === option);
              if(find !== -1){
                return options[find].name;
              }
            }
            if(!isNaN(parseInt(option))){
              let find = options.findIndex((v) => parseInt(v.value) === parseInt(option));
              if(find !== -1){
                return options[find].name;
              }
            }
            return ""
          }}
          renderOption={(props, option) => {
            const { key, ...optionProps } = props;
            return (
              <Box
                dir={dir}
                key={key}
                component="li"
                sx={{ '& > img': { mr: 2, flexShrink: 0 } }}
                {...optionProps}
              >
                {option.name}
              </Box>
            );
          }}
          renderInput={
            (params) => <TextField 
                          {...params} 
                          dir={dir}
                          label={title} 
                          name={name}
                          sx={{
                            fontSize: "0.5rem"
                          }}
                          slotProps={{
                            htmlInput: {
                              ...params.inputProps,
                              autoComplete: 'off',
                            },
                          }}
                        />}
        />
        <div className="error">{errorComp}</div>
      </Styles>
    )
  }
  return (
    <Styles style={style} className={(lan) ? "ltr-all" : ""}>
      <select
        disabled={disabled}
        className={classes + " " + ((disabled) ? "disabled" : "")}
        name={name}
        type="text"
        value={(value) ? value : ""}
        placeholder={placeHolder}
        onChange={onchange}
        required={required}
        onFocus={(e) => setFocused(true)}
        onBlur={(e) => ((value === '') ? setFocused(false) : '')}
      >
        {makeOption()}
      </select>
      <label className={"label-textinput " + ((focused) ? 'active' : '')}>
        {title}
      </label>
      <div className="error">{errorComp}</div>
    </Styles>
  );
};
